import { ReactNode, useEffect, useState } from "react";

import styles from "./style.module.scss";
import cx from "classnames";
import { EDocumentProductDataType } from "@/formTypes/EDocumentProductDataType";
import { useAppSelector } from "@/store/hooks";
import { generateS3AssetUrl } from "@utils/FormFileServer";
import { formatCant } from "@utils/Cant";

type ProductListProps = {
  products: EDocumentProductDataType[]
  productCount: number,
  maxItemPerPage: number,
  productTableClassName?: string
}

const ProductList = (props: ProductListProps) => {
  const suscription = useAppSelector((state) => state.suscription.suscription);
  const { products = [], productCount = 0, maxItemPerPage = 30, productTableClassName } = props;
  const [waterMark, setWaterMark] = useState<URL>()

  useEffect(() => {
    loadWaterMark()
  }, [suscription?.watermark]);


  const loadWaterMark = async () => {
    if (suscription?.watermark && suscription?.watermark != "0") {
      const waterMarkAsset = await generateS3AssetUrl(suscription?.watermark);
      setWaterMark(waterMarkAsset.url)
    }
  }

  const renderProductsRows = (): ReactNode[] => {
    const productRows = products.flatMap(p => {
      const rows = Array();
      const productLine = (
        <tr className="table-row">
          <td>
            <div className={cx({ "codigo": true, "exento": p.exento })}>
              {p.codigo || p.product?.codigo || "temp"}
            </div>
          </td>
          <td>
            <div className={cx({ "product-descrip": true })}>
              {p.product?.codigobarras && (<b>[{p.product?.codigobarras}] </b>)}
              {p.description || p.product?.descripcion_fact}
            </div>
          </td>
          <td>
            <div className={cx({ "product-cant": true })}>
              {formatCant(p.cant)}
            </div>
          </td>
          <td>
            <div className={cx({ "product-precio": true })}>
              {p.price?.toFixed(2)}
            </div>
          </td>
          <td>
            <div className={cx({ "subtotal": true })}>
              {p.subtotal?.toFixed(2)}
            </div>
          </td>
        </tr>
      )
      rows.push(productLine)
      if (suscription?.include_full_desc) {
        const fullDescription = p.product?.descripcion || p.description
        const descriptionRow = (
          <tr>
            <td colSpan={5} className="descripcion-larga">
              {fullDescription}
            </td>
          </tr>
        )
        rows.push(descriptionRow)
      }
      return rows
    });

    addSpacerRows(productRows)

    return productRows
  }

  const addSpacerRows = (productRows: ReactNode[]) => {
    const leftFields = maxItemPerPage - productRows.length;

    for (let i = 0; i < leftFields; i++) {
      productRows.push((
        <tr className="table-row spacer">
          <td>
            <div className="codigo">
              &nbsp;
            </div>
          </td>
          <td>
            <div className="product-descrip">
              &nbsp;
            </div>
          </td>
          <td>
            <div className="product-cant">
              &nbsp;
            </div>
          </td>
          <td>
            <div className="product-precio">
              &nbsp;
            </div>
          </td>
          <td>
            <div className="subtotal">
              &nbsp;
            </div>
          </td>
        </tr>
      ))
    }
  }

  return (
    <div className="invoice-details">
      <div className={cx(["table-heading", styles.sectionTitle])} >
        <div className={cx(["title", styles.title])}>Productos</div>
        <div className="productCount">Productos : {productCount} uds  </div>
      </div>
      <div className="productos-wrapper">
        <table className={cx(["productos", productTableClassName])} cellSpacing="0">
          <thead>
            <tr className="table-titles">
              <th className="codigo">Codigo</th>
              <th className="descripcion">Descripcion</th>
              <th className="cantidad">Cant</th>
              <th className="precio">Precio Unit.</th>
              <th className="subtotal">Monto</th>
            </tr>
          </thead>
          <tbody>
            {renderProductsRows()}
          </tbody>
        </table>
        {waterMark && (
          <img src={`${waterMark}`} alt="Marca de Agua" className="productos-table-water-mark" />
        )}
      </div>
    </div>
  );
}

export default ProductList
  ;
